export default __webpack_public_path__ + "static/firstTime31-8a9914e362df2223338d6d3503a9918b.png";